/**
 * When a route meta has requiresGuest, will redirect logged in users based on store/auth module
 * Will hang and wait, if the auth status is not determined.
 *
 * If route meta has requiresGuestRedirect property - will redirect there
 * Otherwise, will redirect based on app config - config.router.requiresGuestRedirect
 * Finally, if both missing, will redirect to '/' as a last resort.
 * @param router
 * @returns {{handler: handler, routerMethod: string}}
 */
import { isRef, unref } from "vue";
export default (router) => {
  return {
    routerMethod: "saffronBus",
    handler: async (to, from, context) => {
      await router.app.$acl.isReadyPromise;

      if (isRef(context)) {
        context = unref(context);
      }

      const getRejectRedirect = () => {
        // if user - redirect to unauthorized,  else - no user - go to login
        if (router.app.store.getters["user/isLoggedIn"]) {
          return {
            name: config.router.unauthorizedPageName,
            params: { localeSlug: router.app.store.getters["locale/slug"] },
          };
        } else {
          return {
            name: config.router.userLoginPageName,
            params: {
              loginRedirect: to.fullPath,
              localeSlug: router.app.store.getters["locale/slug"],
            },
            query: { redirect: to.fullPath },
          };
        }
      };

      // handle function
      if (typeof context === "function") {
        return (await context({ from, to, context, router }))
          ? true
          : getRejectRedirect();
      }

      // detect the context of a string
      if (
        typeof context === "string" ||
        (context &&
          typeof context === "object" &&
          context?.asset &&
          Object.entries(context).length === 1)
      ) {
        let str = typeof context === "string" ? context : context.asset;
        let split = str.split("|");
        let assetType = split[0];
        let actions = split[1]?.split(",") || undefined;
        let fields = split[2] || undefined;
        let level = split[3] || undefined;
        if (!actions) {
          warn(
            "ACL middle ware - string type context - must be AT LEAST in the form of assetType|actionOrActions - actions are required"
          );
        }

        if (typeof fields === "string" && fields.indexOf(",") !== -1) {
          fields = fields.split(",");
        }

        if (!router.app.$acl.can(assetType, actions, fields, level)) {
          return getRejectRedirect();
        } else {
          return true;
        }
      }

      // context is an array - argument for canMany
      if (Array.isArray(context)) {
        if (!router.app.$acl.canMany(context)) {
          return getRejectRedirect();
        } else {
          return true;
        }
      }

      // detect case of simply one argument for can
      if (utilities.hasAnyProperty(context, ["type", "assetType", "asset"])) {
        if (!router.app.$acl.can(context)) {
          return getRejectRedirect();
        } else {
          return true;
        }
      }

      // if we are here, we have object of pattern {methodName: arg}
      for (const [methodName, methodArg] of Object.entries(context)) {
        if (typeof router.app.$acl[methodName] !== "function") {
          warn(
            "error! acl middle ware - bad config. It seems you pass an object of pattern aclMethod:arg, but one of the keys is not a method name in acl",
            { context }
          );
          return getRejectRedirect();
        }

        if (!router.app.$acl[methodName](methodArg)) {
          return getRejectRedirect();
        }
      }

      return true;
    },
  };
};
